import axios from '../axios';

export default {
  getJournal (options) {
    const params = {};

    if (options.pagination) {
      params.pagination = options.pagination;
    }

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${options.id}/journal/all?` + query.join('&'))
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  importJournal (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/journal/import`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
};
